import axios from 'axios';
import router from '@/router';
import miniToastr from 'mini-toastr';

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: true,
  headers: {
    "Authorization": "Bearer "+sessionStorage.getItem('session'),
  },
  validateStatus: status => {
    return status >= 200 && status < 300;
  },
});

request.interceptors.response.use(
  response => {
    if (response.status >= 200 && response.status < 305) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    console.log('error', error);
    if (error.response != undefined) {
      switch (error.response.status) {
        case 400: {
          miniToastr.error('Bad request', '');
          break;
        }
        case 401: {
          router.push({ path: '/pages/login', query: { redirect: location.href } });
          break;
        }
        case 403: {
          miniToastr.error('Unauthorized', '');
          router.push('/dashboard');
          break;
        }
        case 404: {
          miniToastr.error('Not found', '');
          break;
        }
        case 500: {
          miniToastr.error('Internal error', ' ');
          break;
        }
        case 409: {
          miniToastr.error('Record exists', '');
          break;
        }
        default: {
          miniToastr.error('Something went wrong', '');
          break;
        }
      }
      return Promise.reject(error.response);
    }
  },
);

export default request;
